// export const corporate = [
//   "Arts/Creative/Graphics Design",
//   "Finance",
//   "Clerical/Administrative Support",
//   "Corporate Strategy/Top Management",
//   "Customer Service",
//   "Engineering",
//   "Human Resources",
//   "IT / IS / Computer",
//   "Law/Legal Services",
//   "Logistics/Supply Chain",
//   "Marketing",
//   "Process Design & Control/Instrumentation",
//   "Public Relations/Communications",
//   "Secretarial/Executive & Personal Assistant",
//   "Training & Development"
// ];


//UPDATE AS PER CLIENT
// export const applicationSiteData = [
//   "ATC",
//   "BGC",
//   "Cubao",
//   "Eastwood",
//   "Gilmore",
//   "Glorietta",
//   "MOA",
//   "Shaw",
//   "Online",
// ];


export const applicationSiteData = [
  "ATC",
  "Glorietta",
  "Shaw",
  "Online"
];

export const workExp = [
  "Yes, within the BPO industry.",
  "Yes, outside of the BPO industry.",
  "No, I don't have any previous work experience",
];

export const arr = [
  "Great! I've forwarded the details to our recruitment partners. Please expect a call anytime from 9AM-6PM, Mondays to Fridays (except during holidays). Good luck! :)",
  "Super! I've forwarded the details to our recruitment partners for processing. Please keep your lines open for their call, anytime from 9AM-6PM, Mondays to Fridays (except during holidays). Good luck! :)",
  "Great! Now, for the next steps, our recruitment team will be giving you a call. Please expect their call anytime from 9AM-6PM, Mondays to Fridays (except during holidays). Good luck! :)",
];
//COMMENTED FOR THE 03-24-2021 UPDATE
// export const corporate = [
//   "Executive Assistant, Glorietta 1",
//   "HR Assistant, KPointe",
//   "IPS Staff, WCC",
//   "Web Developer, KPointe",
//   "HR Specialist, Alabang Town Center",
//   "Fraud Risk Management Analyst, Glorietta 1",
//   "AData Security Analyst, Alabang Town Center",
//   "HRSS Data Specialist, Shaw500",
//   "Quality Assurance, Shaw500",
//   "Digital Officer, KPointe",
//   "Training Associate, WCC",
//   "Digital Specialist, KPointe",
//   "HRSS HRIS Systems Specialist, Shaw500",
//   "Business Analyst, Alabang Town Center",
//   "Quality Representative, Shaw500 (2)",
//   "Graphic Design Artist, KPointe",
//   "End User Support, Shaw500 (2)",
//   "Executive Assistant, Alabang Town Center",
// ];

// export const leadership = [
//   "Team Leader, Shaw500",
//   "Sr. Manager – Fraud Risk Management, WCC",
//   "Shared Services Talent Acquisition Director, Shaw500",
//   "OMD Manager, Alabang Town Center",
//   "GRP Manager, Shaw500",
//   "OMD Manager, W City",
//   "HRSS Project Manager, Shaw500",
//   "SR. Systems Manager, Glorietta 1",
//   "Site IT Supervisor, Glorietta 1",
//   "Account Manager, Shaw500",
// ];

// export const multilingual = [
//   "Mandarin Speaking Network Engineer CCNA, Glorietta 1",
// ];

export const leadership = [
  "Sr. Training and Quality Manager, Glorietta 1",
  "Customer Success Manager, Glorietta 1",
  "Quality Manager, Glorietta 1",
  "Team Leader, Shaw500",
  "Sr. IT Incident Manager, WCC",
];

export const corporate = [
  "Senior Technical Support, Shaw500",
  "Project Coordinator, Shaw500",
  "Reports Analyst, Shaw500",
  "GRP Analyst, Alabang Town Center",
  "Report Analyst, Alabang Town Center",
  "Senior Graphic Design Artist, Alabang Town Center",
  "GSOC Specialist I, Alabang Town Center",
  "Data Analyst Specialist, Alabang Town Center",
  "Data Security Analyst, Alabang Town Center",
  "Graphic Design Artist, KPointe",
  "Communication Officer, KPointe",
  "Associate Software Engineer, KPointe",
  "Data Scientist, Glorietta 1",
  "Accounts Payable Specialist, Glorietta 1",
  "Accounts Officer, Glorietta 1",
  "HR Officer, Glorietta 1",
  "Executive Assistant, Glorietta 1",
  "Copywriter-Strategic Content, Glorietta 1",
  "Sr. Graphic Artist, Glorietta 1",
  "Accounts Receivable Specialist, Glorietta 1",
  "Accounting Specialist, Glorietta 1",
  "Netsuite Administrator, Glorietta 1",
  "Internal IT Auditor II, Glorietta 1",
  "Workforce Analyst, Glorietta 1",
  "Sr. Compliance Auditor, Glorietta 1",
  "Internal Auditor, Glorietta 1",
  "Report Analyst, Glorietta 1",
  "Accountant, Glorietta 1",
  "Purchasing Assistant, Glorietta 1",
  "HR Clerk, Glorietta 1",
  "Credit Officer, Glorietta 1",
  "Jr. Account Auditor, WCC",
  "Sr. Compliance Auditor, WCC",
  "GRP Analyst, WCC",
  "Security Operations Specialist, WCC",
  "Global Report Analyst, WCC",
  "Recruitment Officer, WCC",
];

export const multilingual = [
  "Vietnamese Agent, WCC",
  "Japanese TSR, WCC",
  "Japanese TSR, WCC",
  "Spanish CSR, Alabang Town Center",
];